import { render } from "./comprehensieAnswer.vue?vue&type=template&id=6b229914&scoped=true"
import script from "./comprehensieAnswer.vue?vue&type=script&lang=js"
export * from "./comprehensieAnswer.vue?vue&type=script&lang=js"

import "./comprehensieAnswer.vue?vue&type=style&index=0&id=6b229914&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b229914"]])

export default __exports__